module.exports = __webpack_public_path__ + "static/media/wix-print-on-demand.0d7817a9.png";